import { render, staticRenderFns } from "./PackageFeatureComparison.vue?vue&type=template&id=7d587f3b"
import script from "./PackageFeatureComparison.vue?vue&type=script&lang=js"
export * from "./PackageFeatureComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports